import { Typography } from "@graphy/ui";
import Image, { StaticImageData } from "next/image";
import CtaButtonGroup, { CtaType } from "../molecules/CtaButtonGroup";

export type CommunityPlatformSectionType = {
  title: string;
  description: string;
  points: { icon: string; text: string }[];
  ctas: CtaType[];
  image: {
    src: StaticImageData;
    alt: string;
  };
};

const CommunityPlatformSection = ({
  title,
  description,
  points,
  ctas,
  image
}: CommunityPlatformSectionType) => {
  return (
    <div
      className="bg-[url('/images/icons/linkedin-cover-banner.svg')] bg-cover bg-left-top bg-no-repeat mx-4 rounded-3xl md:mx-0 md:rounded-none"
    >
      <div className="page-max-width mx-0 flex flex-col justify-between gap-6 px-4 py-3 md:mx-auto md:flex-row md:items-center md:px-0 md:py-12">
        <div>
          <h3 className="text-left text-title3 font-semibold text-grey-4 sm:text-title1">
            {title}
          </h3>
          <Typography
            fontSize="text-title6"
            fontWeight="font-normal"
            colorClass="text-grey-4"
            className="mt-[6px]"
          >
            {description}
          </Typography>
          <div className="mb-3 mt-4 flex flex-col gap-3 md:my-6">
            {points.map((point, index) => {
              return (
                <div key={point.text} className="flex items-center gap-2">
                  <Image src={point.icon} alt={""} width={16} height={16} />
                  <p className=" text-body-12 font-normal text-grey-4 ">
                    {point.text}
                  </p>
                </div>
              );
            })}
          </div>
          <CtaButtonGroup ctas={ctas} gap="gap-4" fullWidthOnMobile={false} />
        </div>
        <Image
          src={image?.src!}
          alt={image?.alt!}
          width={0}
          height={0}
          sizes="100vw"
          className="mt-4 h-auto w-full md:mt-0 md:h-[228px] md:w-[350px]"
        />
      </div>
    </div>
  );
};

export default CommunityPlatformSection;
